export default __webpack_public_path__ + "static/media/candidate-dashboard.06c18ba7.png";